import { darken } from 'polished';
import styled, { css } from 'styled-components';

interface ContainerProps {
  height?: string;
  isFilled: boolean;
  isFocuses: boolean;
  isErrored: boolean;
  onlySelect?: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: #f9f9f9;
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  padding: 5px 10px;
  width: 100%;
  display: flex;
  align-items: center;
  height: 46px;

  + div {
    margin-top: 8px;
  }

  div {
    width: 100%;
    position: relative;

    .button-show {
      width: 70px;
      font-size: 12px;
      text-align: center;
      background: none;
      border: 0;
      padding: 6px 6px 6px;
      color: #fa8009 !important;
      height: 52px;
      font-weight: bold;
    }
  }

  input {
    width: 100%;
    flex: 1;
    background: transparent;
    border: 0;
    color: #777777;
    transition-duration: 0.2s;
    caret-color: ${(props) => (props.onlySelect ? 'transparent' : 'unset')};
    cursor: ${(props) => (props.onlySelect ? 'default' : 'text')};

    ::placeholder {
      color: #a3a3a3;
    }

    :focus {
      border: none;
      outline: 0;
    }

    :disabled {
      opacity: 0.7;
    }
  }

  .options {
    border-radius: 0 0 10px 10px;
    background-color: #fff;
    border: 1px solid #d3d3d3;
    width: calc(100% + 2px);
    left: -1px;
    top: 44px;
    max-height: 200px;
    overflow: auto;
    z-index: 100;

    button {
      border: none;
      border-bottom: 1px solid #d3d3d3;
      background: transparent;
      transition-duration: 0.3s;
      color: #8692a6;
      min-height: 52px;

      :hover {
        background-color: ${darken(0.02, '#ffffff')};
      }
    }
  }

  svg {
    color: #777777;
    transition-duration: 0.2s;
    pointer-events: none;
  }

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #ff1a50;
    `}

  ${(props) => props.isFilled && css``}

  ${(props) =>
    props.isFocuses &&
    css`
      color: #777777;
      border-color: #f15a29 !important;
      border-radius: 10px 10px 0 0 !important;
    `}
`;
